import {
    Box,
    FormControl,
    FormHelperText,
    IconButton,
    InputAdornment,
    OutlinedInput,
    Typography,
} from '@mui/material'
import { ReactElement, useEffect, useState } from 'react'
import { uploadEntityInstanceImage } from '../../services/entityServices'
import { useAppDispatch, useAppSelector } from '../../redux/hook'
import { CloseOutlined } from '@mui/icons-material'
import TruncatedText from './TruncatedText'
import { updateLoader } from '../../redux/slices/loaderSlice'
import { useTranslation } from 'react-i18next'

interface FileUploadInputProps {
    id: string
    label: string
    value: any
    onChange: any
    required?: boolean
    onEnter?: any
    placeholder?: string
    disabled?: boolean
    errorMessage?: string
    endAdornment?: any
}

const FileUploadInput = (props: FileUploadInputProps): ReactElement => {
    const {
        id,
        label,
        value,
        onChange,
        required,
        onEnter = () => undefined,
        placeholder,
        disabled,
        errorMessage = '',
        endAdornment,
    } = props
    const { t } = useTranslation()

    const org = useAppSelector((state) => state.org.org)

    const dispatch = useAppDispatch()

    const [fileName, setFileName] = useState<string>('')

    useEffect(() => {
        if (value) {
            setFileName(value.name || '') // Update file name if `value` prop changes
        }
    }, [value])

    const onChangeFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(updateLoader(true))
        const file = event.target.files?.[0] || null

        if (file) {
            const formData = new FormData()
            formData.append('entityFile', file, file.name)
            const filePath: {
                type: string
                payload: any
            } = await uploadEntityInstanceImage(org?.id || '', formData)
            if (filePath?.type === 'success') {
                setFileName(file.name)
                const fileValue = {
                    name: file.name,
                    path: filePath?.payload?.url,
                }
                onChange(id, fileValue)
            }
        }
        dispatch(updateLoader(false))
    }

    const onClear = () => {
        setFileName('')
        onChange(id, '')
    }

    const CustomInputComponent: React.FC<any> = (props) => {
        const { value, ...rest } = props
        return (
            <div {...rest}>
                {/* Render the truncated text */}
                <TruncatedText
                    text={value || ''}
                    sx={{ fontSize: 14, color: '#000' }}
                />
            </div>
        )
    }

    return (
        <Box sx={{ width: '100%' }}>
            <FormControl fullWidth>
                <Typography sx={{ opacity: '0.7', fontSize: '14px' }}>
                    {label}
                    {required ? '*' : ''}
                </Typography>
                {fileName ? (
                    <OutlinedInput
                        size="small"
                        id={id}
                        label=""
                        value={fileName}
                        inputComponent={
                            fileName ? CustomInputComponent : undefined
                        }
                        disabled
                        sx={{
                            width: '100%',
                            '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
                                {
                                    display: 'none',
                                },
                            '& input[type=number]': {
                                MozAppearance: 'textfield',
                            },
                            '& ::placeholder': {
                                // opacity: 0.14,
                            },
                            // '&:hover': {
                            //     '& .close-icon': {
                            //         display: 'flex',
                            //     },
                            // },
                        }}
                        // placeholder={
                        //     placeholder ? placeholder : `Enter ${label}`
                        // }
                        inputProps={{
                            style: {
                                fontSize: 14,
                                WebkitTextFillColor:
                                    fileName !== '' &&
                                    fileName !== null &&
                                    !disabled
                                        ? '#000'
                                        : '#00000061',
                            },
                            type: 'text',
                        }}
                        error={errorMessage !== ''}
                        endAdornment={
                            <InputAdornment position="end">
                                {!disabled ? (
                                    <IconButton
                                        id={id + 'close-icon'}
                                        className="close-icon"
                                        sx={
                                            {
                                                // display: 'none',
                                            }
                                        }
                                        onClick={onClear}
                                    >
                                        <CloseOutlined fontSize="small" />
                                    </IconButton>
                                ) : (
                                    <></>
                                )}
                            </InputAdornment>
                        }
                    />
                ) : (
                    <OutlinedInput
                        size="small"
                        id={id}
                        label=""
                        value=""
                        onChange={onChangeFile}
                        // onBlur={(e) => onblur(id, e.target.value)}
                        sx={{
                            width: '100%',
                        }}
                        placeholder={
                            placeholder ? placeholder : t('uploadFile')
                        }
                        inputProps={{
                            style: {
                                fontSize: 14,
                                opacity: !disabled ? '1' : '0.4',
                            },
                            type: `file`,
                            onKeyPress: (e) => {
                                if (e.key === 'Enter') {
                                    onEnter(
                                        id,
                                        (e.target as HTMLInputElement).value,
                                    )

                                    // write your functionality here
                                    e.preventDefault()
                                }
                            },
                        }}
                        disabled={!!disabled}
                        error={errorMessage !== ''}
                        endAdornment={
                            endAdornment ? (
                                <Typography
                                    sx={{
                                        opacity: disabled ? '0.5' : '0.7',
                                        fontSize: '14px',
                                    }}
                                >
                                    {endAdornment}
                                </Typography>
                            ) : (
                                ''
                            )
                        }
                    />
                )}
                {errorMessage !== '' && (
                    <FormHelperText sx={{ color: 'red' }}>
                        {errorMessage}
                    </FormHelperText>
                )}
            </FormControl>
        </Box>
    )
}

export default FileUploadInput
